import React from 'react'
import { connect } from 'react-redux'
import {  Row } from 'react-bootstrap'

import SearchBarDashboard from '../../../components/SearchBarDashboard'
import PropertyTitle from '../../../components/PropertyTitle'
import DateInput from '../../../components/DateInput'
import FontAwesome from 'react-fontawesome'
import Toggle from 'react-toggle'
import 'react-toggle/style.css'


import { fetchLicensesByActivationCode, updateLicense, resetSearchResults } from '../../../actions/license-actions'
import { NO_SEARCH_RESULTS } from '../../messages'

const Checkbox = ({ checked, onChange }) => (
  <label className="toggle" style={{padding:"10px", paddingLeft:"5px", display:"inline-block"}} >
    <span className="label"></span>
    <Toggle
      checked={checked}
      icons={{
        checked: null,
        unchecked: null,
      }}
      onChange={onChange}
    />
  </label>
)

class LicenseAdjustDeactivateBefore extends React.Component {

    constructor() {
        super()
        this.state = { query: '', dateValue: undefined, toggleValue: false, isSearching: false }
      }
    
      componentDidMount() {
      if(!this._isUnmounted) {
        if(this.props.results.query) {
          this.setState({ query: this.props.results.query })
        }
        if(this.props.results[0]){
          this.setState({ toggleValue: this.props.results[0].deactivationPossible })
          if(this.props.results[0].deactivateBefore) {
            this.setState({ dateValue: this.props.results[0].deactivateBefore })
          }
        }
      }
      }

    componentWillUnmount() {
      this._isUnmounted = true;
      if (this.props.results.length > 0 && this.props.resetSearchResults) {
        this.props.resetSearchResults(); // Clear search results on unmount
      }
    }
    
      search(query) {
        this.setState({ query, isSearching: true })
        this.props.fetchLicensesByActivationCode(query).then(() => {
          this.setState({ isSearching: false })
        })
      }

      onChangeDate(dateValue) {
        this.setState({dateValue: dateValue})
      }

      onChangeDeactivationPossible(license) {
        license.deactivationPossible = !license.deactivationPossible
        this.setState({toggleValue: license.deactivationPossible})
      }

      onSave(license) {
        license.deactivateBefore = this.state.dateValue
        this.props.updateLicense(license).then(() => {
          this.props.fetchLicensesByActivationCode(license.activationCode)
        }) 
      }
    
      render() {
        const { results } = this.props
        const license = results[0];

        return <div className='content-licenseAdjustDeactivateBefore' >
          <Row className='dashboardRowContainer'>
            <PropertyTitle 
              icon='key' 
              text=" Licentie ontkoppelbaar maken" 
            />
          <Row >
            <div style={{border:"solid", borderWidth:"1px", borderColor:"lightgray", padding:"10px"}}>
              <div style={{borderBottom:"solid", borderWidth:"1px", borderColor:"lightgray", padding:"5px",  marginBottom:"10px"}}>
              Zoek licenties op basis de activatiecode
                </div>
                <SearchBarDashboard style={{ backgroundColor:"white", padding:"5px",  marginTop:"5px"}}
                placeholder="BOOM-XXXX-XXXX"
                value={this.state.query || this.props.results.query}
                callback={(query) => this.search(query)}
                isLoading={this.state.isSearching}
                />
              </div>
          </Row>
          </Row>
          <Row className='dashboardRowContainer'>
            {results.length? (
            <Row style={{border:"solid", borderWidth:"1px", borderColor:"lightgray", padding:"10px"}}>
              <div className='adjustDeactivateBeforeHeader' style={{fontWeight:"bold"}}>
                <FontAwesome name="key" className={'fa-solid fa-user'} />
                 Licentie
               </div>
               <div style={{display:"flex"}}>
              <Checkbox checked={this.state.toggleValue} onChange={(e) => this.onChangeDeactivationPossible(license)} /> <div style={{marginTop:"10px"}} > Deactivation possible </div>
              </div>
               <div className="date" style={{flexDirection:Row}}>
                  <label style={{marginLeft:"5px"}}> Deactivation before </label>
                  <div id="outer-datepicker" style={{width:"100%", textAlign:"center"}}>
                    <DateInput
                      value={this.state.dateValue ? new Date(this.state.dateValue) : (this.props.dateValue ? new Date(this.props.dateValue) : undefined)}
                      onChange={(dateValue) => this.onChangeDate(dateValue)}
                    />
                    <button className="button-dashboard"
                     onClick={() => this.onSave(license)}>
                        Opslaan
                    </button>
                  </div>
                </div>
            </Row>
            ) : (
              this.state.query && !this.state.isSearching ? <div>{NO_SEARCH_RESULTS}</div> : <div></div>
            ) }
            
          </Row>
        </div>
      }

    
}

  export default connect((state) => { 
    return { 
    results: state.licenses.searchResults
   }}, {
    fetchLicensesByActivationCode,
    updateLicense,
    resetSearchResults,
  })(LicenseAdjustDeactivateBefore)
